module.exports = __webpack_public_path__ + "static/media/the_invisible_women_farmers_desktop.16ae4acf.jpg";